"use client";

import { c as _c } from "react/compiler-runtime";
export function ExploreWaveCardSkeleton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-aspect-[16/10] tw-animate-pulse tw-bg-iron-900" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-h-6 tw-w-3/4 tw-animate-pulse tw-rounded tw-bg-iron-800" />;
    t2 = <div className="tw-mt-2 tw-h-4 tw-w-1/2 tw-animate-pulse tw-rounded tw-bg-iron-800/60" />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-overflow-hidden tw-rounded-xl tw-bg-iron-950 tw-ring-1 tw-ring-inset tw-ring-white/10">{t0}<div className="tw-p-4">{t1}{t2}<div className="tw-mt-3 tw-flex tw-items-start tw-gap-2"><div className="tw-size-4 tw-flex-shrink-0 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /><div className="tw-h-4 tw-flex-1 tw-animate-pulse tw-rounded tw-bg-iron-800/60" /></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}